import * as React from "react";

function SvgDownload(props) {
  return <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.824 11.984v2.176a.43.43 0 01-.432.432H1.856a.43.43 0 01-.432-.432v-2.176H0v2.176A1.84 1.84 0 001.84 16h11.536a1.84 1.84 0 001.84-1.84v-2.176h-1.392z" /><path d="M7.632 12.944c.192 0 .368-.08.496-.208l5.184-5.184-1.008-1.008-3.968 3.984V0H6.912v10.528L2.944 6.544 1.936 7.552l5.184 5.184c.128.144.32.208.512.208z" /></svg>;
}

export default SvgDownload;